export enum VenueTypeEnum {
  ONLINE = "ONLINE",
  PHYSICAL_LOCATION = "PHYSICAL_LOCATION",
}

export interface Venue {
  venueType: VenueTypeEnum;
  venueData: string;
}
